(() => {
  let active;
  let frame;
  function destroy() {
    if (!active) return;
    active.observer.disconnect();
    active.drawerObserver?.disconnect();
    active.mobile.removeEventListener('change', active.onMobileChange);
    active = null;
  }
  function init() {
    const header = document.getElementById('mainHeader');
    const group = document.getElementById('headerGroup');
    if (!header || !group || active?.header === header) return;
    destroy();
    const mobile = matchMedia('(max-width: 1023px)');
    const state = { header, group, mobile, frozenY: null, promoReserve: 0, wasMobile: mobile.matches };
    state.observer = new ResizeObserver(schedule);
    for (const section of group.children) if (section.nodeType === 1 && !section.contains(header)) state.observer.observe(section);
    state.onMobileChange = () => {
      if (!mobile.matches) document.getElementById('menuDrawerBox')?.close?.();
      schedule();
    };
    mobile.addEventListener('change', state.onMobileChange);
    active = state;
    const drawer = document.getElementById('menuDrawerBox');
    if (drawer) {
      const syncDrawer = () => {
        const open = drawer.hasAttribute('open') || drawer.hasAttribute('closing');
        if (open && state.frozenY === null) state.frozenY = window.scrollY;
        if (!open) state.frozenY = null;
        header.querySelector('[data-open="#menuDrawerBox"]')?.setAttribute('aria-expanded', String(drawer.hasAttribute('open')));
        schedule();
      };
      state.drawerObserver = new MutationObserver(syncDrawer);
      state.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['open', 'closing', 'closed'] });
      syncDrawer();
    }
    update();
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(() => { frame = null; update(); }); }
  function update() {
    if (!active?.header.isConnected) { init(); return; }
    const { header, group, mobile } = active;
    const drawer = header.querySelector('#menuDrawerBox');
    const drawerOpen = !!drawer?.hasAttribute('open');
    const footer = drawer?.querySelector('drawer-footer');
    if (footer) {
      const hidden = !mobile.matches || !drawerOpen;
      footer.setAttribute('aria-hidden', String(hidden));
      footer.inert = hidden;
    }
    if (drawer) {
      drawer.inert = mobile.matches && !drawerOpen;
      drawer.setAttribute('aria-hidden', String(drawer.inert));
      if (mobile.matches) {
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', String(drawerOpen));
      } else {
        drawer.removeAttribute('role');
        drawer.removeAttribute('aria-modal');
      }
    }
    const y = Math.max(0, active.frozenY ?? window.scrollY);
    const compressed = y >= (mobile.matches ? 140 : 127);
    const expandedHeight = mobile.matches ? 56 : 88;
    const height = compressed ? (mobile.matches ? 56 : 52) : expandedHeight;
    let promoHeight = 0;
    for (const section of group.children) if (section.nodeType === 1 && !section.contains(header)) promoHeight += section.offsetHeight;
    if (active.wasMobile !== mobile.matches) { active.promoReserve = 0; active.wasMobile = mobile.matches; }
    if (group.querySelector('coretex-ticker.is-closed')) active.promoReserve = 0;
    else active.promoReserve = Math.max(active.promoReserve, promoHeight);
    const offset = Math.max(0, promoHeight - y);
    group.style.setProperty('--hdk-header-reserve', `${active.promoReserve + expandedHeight}px`);
    header.style.setProperty('--hdk-header-offset', `${offset}px`);
    header.dataset.compressed = String(compressed);
    document.body.style.setProperty('--headSpace', `${height + offset}px`);
    const full = header.querySelector('.hdk-brand-full');
    if (full) { full.inert = compressed && !mobile.matches; full.setAttribute('aria-hidden', String(full.inert)); }
  }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', () => { init(); schedule(); });
  document.addEventListener('shopify:section:unload', event => {
    if (active && (event.target === active.header || event.target.contains(active.header))) {
      active.header.querySelector('#menuDrawerBox')?.close?.();
      destroy();
    }
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-open="#menuDrawerBox"]') && active) active.frozenY = window.scrollY;
  }, true);
  init();
})();
